var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      key: _vm.item.model.id,
      class: { current: _vm.isCurrent },
      on: { click: _vm.selectItem },
    },
    [
      _c("div", { staticClass: "flex-grow-1 contact" }, [
        _vm.filemakerId
          ? _c("span", { staticClass: "filemaker-id" }, [
              _vm._v(_vm._s(_vm.filemakerId) + " "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "contact-full-name" }, [
          _vm._v(_vm._s(_vm._f("uppercase")(_vm.fullName))),
        ]),
        _vm._v(" "),
        _vm.phoneNumber
          ? _c("span", { staticClass: "contact-phone-number" }, [
              _vm._v("(" + _vm._s(_vm.phoneNumber) + ")"),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-tooltip",
            { attrs: { content: "Edit", placement: "top-start" } },
            [
              _c(
                "span",
                {
                  staticClass: "btn btn-link btn-link-purple btn-sm",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.edit.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "fas fa-edit" })]
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }